import API from './api';
class Server extends API {
    constructor(options) {
        super();
        this.targetOrigin = '*';
        this.client = {
            emit: (event, data) => {
                const listeners = this.listeners[event];
                if (listeners) {
                    listeners.forEach(listener => listener(data));
                }
            }
        };
        Object.assign(this, options);
        window.addEventListener('message', ({ data }) => this.socketEvent(data));
    }
    /**
     * Emits an event to the client
     * @param event Event name
     * @param data Event data
     */
    emit(event, data) {
        console.debug(`[embed-api] emit '${event}'`, data);
        if (!window.parent)
            return false;
        const parsed = JSON.stringify({
            widgetbot: true,
            id: this.id,
            event,
            data
        });
        window.parent.postMessage(parsed, this.targetOrigin);
        return true;
    }
}
export default Server;
//# sourceMappingURL=server.js.map


//////////////////
// WEBPACK FOOTER
// .-api/dist/server.js
// module id = 193
// module chunks = 0